var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":"0 0 24 24","fill":"none","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","stroke":_vm.color}},[_c('line',{attrs:{"x1":"18","y1":"6","x2":"6","y2":"18"}}),_c('line',{attrs:{"x1":"6","y1":"6","x2":"18","y2":"18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }